<div class="order-header">
  <pdq-button size="large" icon="side_left_arrow" (onClick)="backToBatch()" variant="light"></pdq-button>
  <span class="order-header__batch-name">{{ batch.name }}</span>
  <span class="order-header__seperator">></span>
  <span class="order-header__order">
    @if (eCommerceOrderExternalLink) {
      <span>
        <a
          [href]="eCommerceOrderExternalLink"
          style="color: var(--on-surface-default)"
          rel="noopener noreferrer"
          [target]="'_blank'">
          Order
          {{ fulfillService.shopMetadata?.displayExternalOrderNumber ? order.externalOrderNumber : order.orderNumber }}
          @if (order.splitted) {
            <span>-{{ orderSplitIndices }}</span>
          }
        </a>
      </span>
    } @else {
      <span>
        Order
        {{ fulfillService.shopMetadata?.displayExternalOrderNumber ? order.externalOrderNumber : order.orderNumber }}
        @if (order.splitted) {
          <span>-{{ orderSplitIndices }}</span>
        }
      </span>
    }
  </span>
  <app-back-to-assign-btn
    class="order-header__move-back"
    [batch]="batch"
    [order]="order"
    label="Move back to assign"></app-back-to-assign-btn>
  <div class="print-wrapper">
    @if (isPickAndPackFocus) {
      <pdq-dropdown
        icon="print"
        type="actionList"
        placeholder="Print"
        [options]="printOptions"
        [sections]="printSections"
        align="right"
        (onChange)="printOrder.emit($event)"></pdq-dropdown>
    }
  </div>
</div>
